import { ChevronsLeft, ChevronsRight } from 'lucide-react';

import { Button } from '../../components/Button';
import { markAfter, markBefore, preRollMs, type TimelineMark } from './marks';

/** Previous/next event buttons; a jump starts a few seconds before the event. */
export function EventJumps({
  marks,
  playhead,
  dayStart,
  onSeek,
}: {
  marks: TimelineMark[];
  playhead: number | null;
  dayStart: number;
  onSeek: (t: number) => void;
}) {
  if (marks.length === 0) return null;
  const at = playhead ?? dayStart;
  const prev = playhead === null ? null : markBefore(marks, at);
  const next = markAfter(marks, playhead === null ? dayStart - 1 : at);
  const jump = (m: TimelineMark) => {
    onSeek(Math.max(m.at - preRollMs, dayStart));
  };
  return (
    <div role="group" aria-label="Registros" className="flex gap-1">
      <Button
        aria-label="Registro anterior"
        title={prev ? `Registro anterior: ${prev.label}` : 'Nenhum registro antes'}
        disabled={prev === null}
        onClick={() => {
          if (prev) jump(prev);
        }}
      >
        <ChevronsLeft aria-hidden="true" className="size-4" />
      </Button>
      <Button
        aria-label="Próximo registro"
        title={next ? `Próximo registro: ${next.label}` : 'Nenhum registro depois'}
        disabled={next === null}
        onClick={() => {
          if (next) jump(next);
        }}
      >
        <ChevronsRight aria-hidden="true" className="size-4" />
      </Button>
    </div>
  );
}
